module.exports = __webpack_public_path__ + "img/zuantao.prt.172c5162.jpg";